export const inputMaxLength = 30;
export const zipMaxLength = 10;
export const emailMaxLength = 40;

export const onlyASCII = /^[\x20-\x7E“”‘’]*$/;
export const messageRegex = /^[\x20-\x7E\r\n“”‘’]*$/;
export const nameRegex = /^(?![ .\-‘’']*$)[a-zA-Z .\-‘’']+$/;
export const addressRegex = /^[A-Za-z0-9\s\-.,()&'‘’#/]*$/;
export const zipCodeRegex = /^\d{5}(-\d{4})?$/;
export const phoneRegex = /^\d+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const notUseStateNames =  ['Alaska', 'AK', 'Hawaii', 'HI', 'Puerto Rico', 'PR', 'Armed Forces Americas', 'AA',
  'Armed Forces Africa', 'Armed Forces Canada', 'Armed Forces Europe', 'Armed Forces Middle East',
  'Armed Forces Pacific','AE', 'Guam', 'GU'];
